import { mapGetters, mapActions } from 'vuex'

import headers from './headers'
import { DisplaySwitchButton, NormalButton } from '@/components/items'

import EcReceiveorderTable from './EcReceiveorderTable'

export default {
  components: {
    DisplaySwitchButton,
    NormalButton,
    EcReceiveorderTable
  },
  props: {
    isEditPage: { default: false },
    selectCurrency: {
      type: Object,
      require: true
    },
    search: {}
  },
  data: () => ({
    openPanelIndex: [],
    groupNames: [],
    pageEcReceiveorderList: [], // フィルタリング後の表示用リスト
    masterEcReceiveorderList: [], // APIから取得した全件マスタリスト
    headers: headers.headers,

    errDialog: false,
    listKey: 0
  }),
  async created() {
    this.setIsLoading(true)
    try {
      this.initHeaders()
      // ▼▼▼ 修正点：初期化時にAPIで全件取得し、マスタリストに保存 ▼▼▼
      await this.fetchMasterList()
      // ▼▼▼ 修正点：初期フィルタ（空）を適用して表示 ▼▼▼
      this.applyFilters()
    } finally {
      this.setIsLoading(false)
    }
  },
  methods: {
    ...mapActions('Nextengine', ['getEcReceiveorderListFromApi']),
    ...mapGetters('Nextengine', ['getEcReceiveorderListFromState']),
    ...mapActions('Common', ['setIsLoading']),

    // ▼▼▼ 削除：init() メソッドは created に統合 ▼▼▼
    // async init() { ... }

    initHeaders() {
      this.headers = headers.headers
    },

    getSupplierIsEnabled(id) {
      const supplier = this.getSuppliersFromState().find(
        (ele) => ele.supplierId === id
      )
      return supplier.isEnabled
    },

    // ▼▼▼ 新規：APIからデータを取得しマスタリストを作成するメソッド ▼▼▼
    async fetchMasterList() {
      await this.getEcReceiveorderListFromApi()
      const allData = this.getEcReceiveorderListFromState()

      // データを加工し、マスタリストに保存
      this.masterEcReceiveorderList = allData.map((ele) => {
        return {
          ...ele,
          ecReceiveorderId: ele.ecReceiveorderId,
          importCreateGroup: ele.importDateGroup, // ソート用の値
          invalid: false
        }
      })
    },

    // ▼▼▼ 修正：「createEcReceiveorderListData」から「applyFilters」に名前変更・ロジック修正 ▼▼▼
    applyFilters() {
      // フィルタリングの際はAPIを呼ばず、マスタリストから処理を開始する
      let filteredList = [...this.masterEcReceiveorderList]

      if (this.search) {
        // 日付(From)でのフィルタリング
        if (this.search.importDate && this.search.importDate.start) {
          filteredList = filteredList.filter((item) => {
            return item.importDateGroup >= this.search.importDate.start
          })
        }
        // 日付(To)でのフィルタリング
        if (this.search.importDate && this.search.importDate.end) {
          filteredList = filteredList.filter((item) => {
            return item.importDateGroup <= this.search.importDate.end + ' 23:59'
          })
        }
        // 伝票番号でのフィルタリング (部分一致)
        if (this.search.receiveOrderId) {
          filteredList = filteredList.filter((item) =>
            String(item.receiveOrderId).includes(this.search.receiveOrderId)
          )
        }
        // 受注番号でのフィルタリング (部分一致)
        if (this.search.receiveOrderShopCutFormId) {
          filteredList = filteredList.filter((item) =>
            String(item.receiveOrderShopCutFormId).includes(
              this.search.receiveOrderShopCutFormId
            )
          )
        }
        // 「Spes販売登録済みの受注伝票を表示しない」チェックボックスのフィルタリング
        if (this.search.invalidDisplayFlg) {
          // 販売ステータスが1(登録済み)・2(登録済み※金額ズレあり)・3(ステータス更新待ち)の受注伝票を除外
          filteredList = filteredList.filter((item) => {
            return ![1, 2, 3].includes(item.saleStatus)
          })
        }
      }

      // フィルタリング後のリストを表示用データセット
      this.pageEcReceiveorderList = filteredList

      // フィルタリング後のリストを元にグループ名を再設定
      this.setGroupNames()
    },
    // ▲▲▲ 修正ここまで ▲▲▲

    isName(header, name) {
      return header.value === name
    },

    setGroupNames() {
      // ▼▼▼ 修正点：参照先を ecReceiveorderList から pageEcReceiveorderList に変更 ▼▼▼
      const ecReceiveorderListTmp = [...this.pageEcReceiveorderList]

      this.groupNames = ecReceiveorderListTmp
        .sort((a, b) => {
          if (a.createdAt < b.createdAt) return -1
          if (a.createdAt > b.createdAt) return 1
          return 0
        })
        .reduce((result, current) => {
          var importCreateGroup = current.importDateGroup
          var element = result.find((p) => p.groupId === importCreateGroup)
          if (!element) {
            result.push({
              groupId: importCreateGroup,
              open: false,
              index: result.length
            })
          }
          return result
        }, [])
    },
    isOpenPanelOpen(id) {
      const group = this.groupNames.find((p) => p.groupId === id)
      return group ? group.open : false
    },

    setGroupNamesOpen(newVal) {
      this.groupNames = this.groupNames.map((data, index) => {
        data.open = newVal.find((val) => val === data.index) !== undefined
        return data
      })
    },
    detail(ecReceiveorderData) {
      this.$emit('detail', ecReceiveorderData)
    },
    register(ecReceiveorderLists) {
      this.$emit('register', ecReceiveorderLists)
    },

    // ▼▼▼ 修正点：ステータス更新時はマスタリストを更新し、フィルタを再適用する ▼▼▼
    updateStatusByIds(ids) {
      if (!ids || ids.length === 0) return

      // マスタリストのデータを更新
      this.masterEcReceiveorderList = this.masterEcReceiveorderList.map(
        (order) => {
          if (ids.includes(order.ecReceiveOrderId)) {
            console.log('ステータスを3に更新')
            return { ...order, saleStatus: 3 }
          }
          return order
        }
      )

      // マスタリストの更新を反映するため、フィルタを再適用
      this.applyFilters()

      this.listKey += 1
    }
  },
  watch: {
    openPanelIndex: function (val) {
      this.setGroupNamesOpen(val)
    },
    search: {
      deep: true,
      // ▼▼▼ 修正点：init() ではなく applyFilters() を呼ぶ ▼▼▼
      handler(newVal, oldVal) {
        this.applyFilters()
      }
    }
  }
}
